import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#333',
      contrastText: '#FFFFFF',
    },
  },  
});

const buttonStyles = {
  fontFamily: `'Raleway', Helvetica, sans-serif !important`,
  fontWeight: 'bold',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'lightgray',
  }
};

const TableOfContents = ({ sections = [], setSection, selectedSection }) => { 
  return (
    <ThemeProvider theme={theme}>
          <Box>
              
          <ButtonGroup
          orientation="vertical"
          aria-label="vertical contained button group"
          variant="contained"
          color="primary"
          sx={{
            marginTop: '0px',
            width: '300px', // Default width
            '@media (max-width: 450px) and (min-width: 290px)': {
              width: '100%', // Set the width to 100% for viewport width between 420px and 290px
            },
          }}
        >
              {sections.map((section, index) => (
                <Button 
                  key={index} 
                  onClick={() => setSection(section)}
                  variant={selectedSection === section ? 'contained' : 'outlined'}
                  sx={{
                    ...buttonStyles,
                    color: selectedSection === section ? 'white' : 'black'
                  }}
                >
                  {section}
                </Button> 
              ))}
            </ButtonGroup>
          </Box>

    </ThemeProvider>
  );
};

export default TableOfContents;
